import { _ as _sfc_main } from "./VaDropdownContent.vue_vue_type_script_lang-59041f19.mjs";
import { openBlock, createElementBlock, normalizeStyle, renderSlot } from "vue";
import { _ as _export_sfc } from "../../../../../plugin-vue_export-helper-cc2b3d55.mjs";
const VaDropdownContent_vue_vue_type_style_index_0_lang = "";
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: "va-dropdown__content",
    style: normalizeStyle(_ctx.computedStyle),
    role: "listbox"
  }, [
    renderSlot(_ctx.$slots, "default")
  ], 4);
}
const _VaDropdownContent = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
export {
  _VaDropdownContent as _
};
//# sourceMappingURL=VaDropdownContent-47086108.mjs.map
